// extracted by mini-css-extract-plugin
module.exports = {"loader_container":"Loader_loader_container__2f0Nj","loadingphase":"Loader_loadingphase__3RQpj","spin":"Loader_spin__2Yd2a"};